import { CSS_CDN_URL } from "@wix/design-system";
function loadCSS() {
  const link = document.createElement("link");
  link.href = CSS_CDN_URL;
  link.rel = "stylesheet";
  link.onerror = () => {
    console.error(`Failed to load CSS from ${CSS_CDN_URL}`);
  };
  document.head.append(link);
}
export {
  loadCSS
};
//# sourceMappingURL=load-css.js.map
